import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { Platform } from 'ionic-angular';
import { Subject, Subscription } from 'rxjs';
import { AppPreferences, Preference } from '../../shared/local/app-preferences.local';
import { ResponseUserMenuDto } from '../../shared/nestjs/gd-integrated/dto/core.dto';
import { SF7Api } from '../../shared/nestjs/sf7/core.api';
import { FileDownloaderProvider } from '../file-downloader/file-downloader';
import { StoragePathProvider } from '../storage-path/storage-path';
import { Storage } from '@ionic/storage';

@Injectable()
export class Sunfish7Provider {
  private subscriptions: Subscription[] = [];
  private destroy$ = new Subject();
  public browserExit$ = new Subject();
  constructor(
    public storage: Storage,
    private inAppBrowser: InAppBrowser,
    private sf7Api: SF7Api,
    private platform: Platform,
    private appPreferences: AppPreferences,
    private fileDownloaderProvider: FileDownloaderProvider,
    private storagePathProvider: StoragePathProvider,
  ) { }

  dispose() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  getMenu() {
    return new Promise<ResponseUserMenuDto[]>((resolve, reject) => {
      this.subscriptions.push(
        this.sf7Api.userMenu()
          .map(res => res.data)
          .subscribe(async (result) => {
            await this.appPreferences.setGreatdayStorage(Preference.MenuSF7, result);
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  async openPage(route: string) {
    const lang = await this.storage.get('language');
    const baseUrl = this.appPreferences.dataSaas.SF7PATH;
    const url = `${baseUrl}/${route}?sfssokey=${this.appPreferences.dataAuth['sfssokey']}&hide_sidemenu=true&hide_navbar=true&coid=${this.appPreferences.dataAuth['accId']}&clang=${lang}`;
    return this.openInAppBrowser(url);
  }


  openInAppBrowser(url, target: string = '_blank') {
    if (this.platform.is('cordova')) {
      const defaultOptions: InAppBrowserOptions =
        this.platform.is('android') ? {
          zoom: "no",
          location: "no",
          hidden: "no",
          clearcache: "yes",
          clearsessioncache: "yes",
          hardwareback: "yes",
          toolbar: "no",
          beforeload: 'get'
        } : {
          zoom: "no",
          location: "no",
          hidden: "no",
          clearcache: "yes",
          clearsessioncache: "yes",
          toolbar: "no",
        };
      const browser = this.inAppBrowser.create(url, target, defaultOptions);
      browser.show();
      browser.on('exit')
        .takeUntil(this.destroy$)
        .subscribe(() => {
          console.log('browser closed');
          this.browserExit$.next(true);
          this.destroy$.next();
          this.destroy$.complete();
        }, err => {
          console.error(err);
        });
      browser.on("message")
        .subscribe((res: any) => {
          console.log(" postmessage received");
          const postObject: any = res;
          if (postObject.data.message) {
            if (postObject.data.message === "exit") {
              browser.close();
            }
          }
        });
      if (this.platform.is('android')) {
        browser.on('beforeload').subscribe(async e => {
          let url = e.url;
          var extension = this.ext(url);
          if (extension) {
            browser.close();
            await this.platform.ready();
            const nameFile = `File${Math.floor(Math.random() * 999999999)}${this.extName(url)}`;
            url = await this.getUrlFull(url);
            let position = url.search(/sys.sec.getimage/i);
            if (position !== -1) {
              await this.download(this.storagePathProvider.sfGetImage(url), nameFile);
            } else {
              await this.download(url, nameFile);
            }
          }
        });
      } else if (this.platform.is('ios')) {
        browser.on('loadstart').subscribe(async e => {
          let url = e.url;
          var extension = this.ext(url);
          if (extension) {
            browser.close();
            await this.platform.ready();
            const nameFile = `File${Math.floor(Math.random() * 999999999)}${this.extName(url)}`;
            url = await this.getUrlFull(url);
            let position = url.search(/sys.sec.getimage/i);
            if (position !== -1) {
              await this.download(this.storagePathProvider.sfGetImage(url), nameFile);
            } else {
              await this.download(url, nameFile);
            }
          }
        });
      }
    } else {
      const win = window.open(url);
      win.focus();
      win.addEventListener('pagehide', (data) => console.log('page hide', data))
    }
  }

  updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  async download(urlDownload: string, customName: string = '') {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this.fileDownloaderProvider.downloadWithHttp(urlDownload, '', customName);
        resolve();
      }
      catch (error) {
        reject(error);
      }
    });
  }

  ext(url) {
    const ages = ['.pdf', '.doc', '.docx', '.png', '.jpg', '.xls', '.xlsx', '.zip', '.rar', '.ppt', '.pptx'];
    return ages.some((el) => {
      let result = url.indexOf(el);
      return result !== -1;
    });
  }

  extName(url) {
    const ages = ['.pdf', '.doc', '.docx', '.png', '.jpg', '.xls', '.xlsx', '.zip', '.rar', '.ppt', '.pptx'];
    let ext = '.txt';
    ages.some((el) => {
      let result = url.indexOf(el);
      if (result !== -1) {
        ext = el;
        return true;
      }
    });
    return ext;
  }

  async getUrlFull(url) {
    url = decodeURI(url);
    url = '{' + url.split('{')[1];
    var result = url.substring(
      url.indexOf("{") + 1,
      url.lastIndexOf("}")
    );
    const sfgoAuth = await this.appPreferences.getAuth();
    const dummyUrl = sfgoAuth[result];
    return url.replace('{' + result + '}', dummyUrl);
  }

}



// WEBPACK FOOTER //
// ./src/providers/sunfish7/sunfish7.provider.ts